const PDF_TYPES = new Set(["application/pdf"]);
const LEDGER_TYPES = new Set([
  "application/pdf",
  "text/csv",
  "application/vnd.ms-excel",
  "text/plain",
]);

const PDF_EXT = /\.pdf$/i;
const LEDGER_EXT = /\.(pdf|csv)$/i;

/**
 * @param {File} file
 * @param {"assessment"|"ledger"} stream
 * @returns {{ valid: boolean, error?: string }}
 */
export function validateIntakeFile(file, stream) {
  if (!file) {
    return { valid: false, error: "No file selected." };
  }

  const maxBytes = 10 * 1024 * 1024;
  if (file.size > maxBytes) {
    return { valid: false, error: "File exceeds 10 MB limit." };
  }

  if (stream === "assessment") {
    const ok = PDF_TYPES.has(file.type) || PDF_EXT.test(file.name);
    if (!ok) {
      return { valid: false, error: "Assessment notice must be a PDF." };
    }
    return { valid: true };
  }

  const ok = LEDGER_TYPES.has(file.type) || LEDGER_EXT.test(file.name);
  if (!ok) {
    return { valid: false, error: "Asset ledger must be PDF or CSV." };
  }
  return { valid: true };
}
